import React from 'react';

import { CardCvcElement } from '@stripe/react-stripe-js';
import type { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';

import { stripeElementDomId } from '#src/app/shared/utils/payments';

import { useHideAriaHiddenStripeInputsFromTabOrder } from '../../hooks';

type Props = {
	onChange?: (event: StripeCardCvcElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardCvcElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	const containerRef = useHideAriaHiddenStripeInputsFromTabOrder();

	return (
		<div ref={containerRef}>
			<CardCvcElement
				id={stripeElementDomId('cardCvc')}
				options={{ style: { base: { fontSize: '16px' } } }}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</div>
	);
};
